import React from 'react'
import { Box, Button, Typography, Link, useTheme } from '@mui/material'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faHouse } from '@fortawesome/free-solid-svg-icons'
import { ROUTES } from '../routes/routes'
import SEOHelmet from '../components/SEOHelmet'
import { DEFAULT_SEO, generateCanonicalUrl } from '../utils/seo'

const NotFoundPage: React.FC = () => {
  const theme = useTheme()

  return (
    <>
    <SEOHelmet
      {...DEFAULT_SEO.NOT_FOUND}
      canonicalUrl={generateCanonicalUrl(ROUTES.NOT_FOUND)}
    />
    <Box display="flex" flexDirection="column" pt={18} pb={18}
      sx={{ alignItems: 'center', backgroundColor: theme.palette.custom.backgroundWhisperPurple, minHeight: 'calc(100vh - 151px)' }}>
      <Typography component="h1" sx={{
        typography: {
          xs: 'h5',
          sm: 'h4',
          md: 'h4',
          lg: 'h3'
        }
      }} gutterBottom>Page not found</Typography>
      <Link href={ROUTES.HOME} color='white' underline="none" mt={10}>
        <Button
          sx={{
            background: theme.palette.custom.beautifulGradient
          }}
          variant="contained"
          size="large"
        >
          Return to homepage <FontAwesomeIcon icon={faHouse} style={{ marginLeft: '8px', fontSize: '1rem' }} />
        </Button>
      </Link >
    </Box>
    </>
  )
}

export default NotFoundPage
